export const exceptionConstants = {
  UNKNOWN_ERROR: 'Something Went Wrong',
};
